import React, { Component } from 'react';
import { Translate } from "react-localize-redux";


class ContainerTranslation extends Component {

  render(){
    return <Translate >
      {({ translate }) => {
        if(translate(this.props.id) === ""){
           return null
        }else{
          switch (this.props.tag) {
            case "h2":
              return <h2>{translate(this.props.id)}</h2>
            case "span":
              return <span>{translate(this.props.id)}</span>
            case "p":
              return <p>{translate(this.props.id)}</p>
            default:
              return translate(this.props.id)
          }
        }
      }
      }
    </Translate>
  }

}

export default ContainerTranslation;
